import React from 'react';
import styles from './coverage.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Custom segmented control (the use-case Scenarios/Invariants switch).
 * LTSegmentedControl only takes image-src icons and has no counter slot,
 * so this replicates the LT/Primer look: muted track, white active
 * segment, leading 16px icon + label + counter pill.
 */
export function SegmentedTabs(_ref) {
  var options = _ref.options,
    value = _ref.value,
    onChange = _ref.onChange,
    ariaLabel = _ref.ariaLabel;
  return /*#__PURE__*/_jsx("div", {
    className: styles.segControl,
    role: "tablist",
    "aria-label": ariaLabel,
    children: options.map(function (opt) {
      var active = value === opt.value;
      return /*#__PURE__*/_jsxs("button", {
        type: "button",
        role: "tab",
        "aria-selected": active,
        className: "".concat(styles.segBtn, " ").concat(active ? styles.segBtnActive : ''),
        onClick: function onClick() {
          return onChange(opt.value);
        },
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.segIcon,
          "aria-hidden": "true",
          children: opt.icon
        }), opt.label, /*#__PURE__*/_jsx("span", {
          className: styles.segCount,
          children: opt.count
        })]
      }, opt.value);
    })
  });
}